import { Link } from "react-router";
import { useI18n } from "@wato/i18n/react";
import { mayUse } from "../roles/role-label";
import { useWorkspace } from "../workspace/WorkspaceContext";
import { QUICK_ACTIONS } from "./quick-actions";

/** OWN-150a: shortcut row; actions the member's role can't use are not shown. */
export function HomeQuickActions({ workspaceId }: { readonly workspaceId: string }) {
  const { t } = useI18n();
  const { workspace } = useWorkspace();
  const actions = QUICK_ACTIONS.filter((a) => mayUse(workspace, a.permission));
  if (actions.length === 0) return null;
  return (
    <nav
      aria-label={t("dashboard.home.quickActions.title")}
      data-testid="home-quick-actions"
      className="flex flex-wrap gap-2"
    >
      {actions.map((a) => (
        <Link
          key={a.id}
          to={`/w/${workspaceId}/${a.to}`}
          data-testid={`home-quick-${a.id}`}
          className="inline-flex min-h-11 items-center rounded-xl bg-app-surface-2 px-4 text-sm font-medium text-app-fg no-underline hover:bg-app-line"
        >
          {t(a.label)}
        </Link>
      ))}
    </nav>
  );
}
